var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#121212",
    opacity: 0.4,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.0008 14c.2549.0003.5001.0979.6854.2728.1853.175.2969.4142.3118.6686.015.2544-.0678.505-.2314.7004-.1636.1955-.3957.3211-.6488.3512l-.117.007h-.081l-.919 11c.0001.7652-.2923 1.5015-.8172 2.0583-.525.5567-1.2429.8918-2.0068.9367l-.176.005h-8c-1.598 0-2.904-1.249-2.992-2.75l-.005-.167-.923-11.083h-.08c-.2548-.0003-.5-.0979-.6853-.2728-.1854-.175-.2969-.4142-.3118-.6686-.015-.2544.0678-.505.2314-.7004.1636-.1955.3956-.3211.6487-.3512l.117-.007zm-6-4c.5305 0 1.0392.2107 1.4143.5858.375.3751.5857.8838.5857 1.4142-.0002.2549-.0978.5-.2728.6854-.175.1853-.4141.2968-.6685.3118-.2545.0149-.505-.0679-.7005-.2315-.1954-.1636-.3211-.3956-.3512-.6487l-.007-.117h-4l-.007.117c-.0301.2531-.1557.4851-.3511.6487-.1955.1636-.446.2464-.7005.2315-.2544-.015-.4935-.1265-.6685-.3118-.175-.1854-.2726-.4305-.2729-.6854-.0001-.5046.1905-.9906.5335-1.3605.3431-.37.8134-.5967 1.3165-.6345l.15-.005z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.27281ae76abd43636e23414980aff3ef.svg";
export { ForwardRef as ReactComponent };